export default __webpack_public_path__ + "static/media/Blog.ba6b4047.svg";